import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews.js';

// Include all block.js / block.vue's, except form admin. Include from this module as well as from the app.
AutoloadViews.load('canvas::canvas.block', require.context('./../components/canvas/blocks/', true, /^((?!admin).)*\/block.(js|vue)$/));
AutoloadViews.load('canvas.block', require.context('@app/resources/components/canvas/', true, /^((?!admin).)*\/block.(js|vue)$/));

AutoloadViews.load('canvas::editor', require.context('./editor/admin/', true, /\.(js|vue)$/));
